//@ts-nocheck
import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import { Theme, Typography, InputLabel, Input } from "@material-ui/core";
import InputAdornment from "@material-ui/core/InputAdornment";

const useStyles = makeStyles((theme: Theme) => ({
  formInput: {},
  required: {
    fontSize: "12px",
    color: "#ff0000",
    lineHeight: "17px",
  },
}));
// /^[a-zA-Z0-9]*/
// /^([a-zA-Z0-9\s@,=%$#&_\u0600-\u06FF]).{0,30}$/
// /a-zA-Z0-9!@#\$%\^\&*\)\(+=._-/g
const ALPHABETICAL = /^[a-zA-Z0-9\- _!@#.+\u0600-\u06FF]*/;

export default function (props: any) {
  const classes = useStyles();

  const onChange = (evt: any) => {
    const val = evt.target.value.match(ALPHABETICAL)[0];
    //const val = evt.target.value;
    props.onChange(val ? val : "");
  };
  return (
    <>
      <Input
        className={classes.formInput}
        endAdornment={
          props.icon ? (
            <InputAdornment position="end">{props.icon}</InputAdornment>
          ) : null
        }
        value={props.value}
        disabled={props.disabled}
        placeholder={props.placeholder}
        inputProps={{ type: props.type }}
        onChange={onChange}
      ></Input>
      {props.requiredText ? (
        <p className={props.loginRequired ? "login-required" : "required"}>
          {props.requiredText}
        </p>
      ) : null}
    </>
  );
}
